// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__WlnMF","modal":"Modal_modal__1Brqj","slide-down":"Modal_slide-down__1S5zT"};